import * as yup from 'yup';

export const NursingHomeRecordHeaderSchema = yup.object({
  capacity: yup.number().required().min(1),
  occupiedBeds: yup.number().required(),
});

export interface INursingHomeRecordHeader {
  capacity: number;
  occupiedBeds: number;
}
